module.exports = __webpack_public_path__ + "img/egrain1.f145bac0.png";